export const CommonComponents={
    "选择时间":"選擇時間",
    "不限制":"不限制",
    "不限":"不限",
    "添加文件类型":"添加文件類型",
    "请输入文件类型":"請輸入文件類型",
    "请选择文件类型":"請選擇文件類型",
    "确定要删除文件类型":"確定要刪除文件類型",
    "删除后将不可恢复":"刪除後將不可恢復",
    "设置满分条件":"設置滿分條件",
    "满分条件":"滿分條件",
    "回复":"回復",
    "条满分":"條滿分",
    "选择小组批次":"選擇小組批次",
    "请选择小组批次":"請選擇小組批次",
    "立即发布":"立即發布",
    "请选择要发送的学生":"請選擇要發送的學生",
    "暂时不支持视频播放":"暫時不支持視頻播放",
    "暂时不支持音频播放":"暫時不支持音頻播放",
    "下载":"下載",
    "发送":"發送",
    "个附件":"個附件",
    "上传":"上傳",
    "外部浏览器打开":"外部瀏覽器打開",
    "点击下载":"點擊下載",
    "由于微信浏览器本身的限制":"說明：由於微信瀏覽器本身的限制，不允許直接下載，請按照上面圖示，選擇瀏覽器，在瀏覽器裏下載",
    "答题卡":"答題卡",
    "已完成":"已完成",
    "数值":"數值",
    "正确答案":"正確答案",
    "我的答案":"我的答案",
    "试题解析":"試題解析",
    "点击过快":"點擊過快，正在保存答案中...",
    "请输入答案":"請輸入答案",
    "参考答案":"參考答案",
    "保存答题":"保存答題",
    "对":"對",
    "错":"錯",
    "如有描述":"如有描述，請輸入",
    "本题得分":"本題得分",
    "分值":"分值",
    "分":"分",
    "项":"項",
    "匿名":"匿名",
    "实名":"實名",
    "难度":"難度",
    "第一题":"第壹題",
    "最后一题":"最後壹題",
    "下一题":"下壹題",
    "上一题":"上壹題",
    difficulty:{
        "易":"易",
        "中":"中",
        "难":"難",
    },
    SubjectType:{
        "判断题":"判斷題",
        "单选题":"單選題",
        "多选题":"多選題",
        "简答题":"簡答題",
        "投票单选":"投票單選",
        "投票多选":"投票多選",
        "数值评价题":"數值評價題",
        "匿名开放题":"匿名開放題",
        "拍照题":"拍照題",
        "段落说明题":"段落說明題",
        "不定项选择题":"不定項選擇題",
        "填空题":"填空題",
        "文件题":"文件題",  
    },
    Comment:{
        "实名发表":"實名發表",
        "发表内容":"發表內容",
    },
    "确认提交":"確認提交？",
    "提交之后将无法进行更改":"提交之後將無法進行更改",
    "全部题型":"全部題型",
    "按题号排序":"按題號排序",
    "按得分率排序":"按得分率排序",
    "人参与":"人參與",
    "人":"人",
    "得分率":"得分率",
    "查看学生作答":"查看學生作答",
    "确认要删除此错题吗":"確認要刪除此錯題嗎",
    "删除后无法恢复":"刪除後無法恢復!",
    "题号":"題號",
    "查看试题答案及解析":"查看試題答案及解析",
    "暂无":"暫無",
    "人答题":"人答題",
    "展示词云":"展示詞雲",
    "学习中":"學習中",
    "未学习":"未學習",
    "学习状态":"學習狀態",
    "已学习":"已學習",
    "请选择":"請選擇",
    "会议号":"會議號：",
    "会议密码":"會議密碼：",
    "会议时间":"會議時間：",
    "搜索学生姓名学号":"搜索學生姓名、學號",
    "发布时间":"發布時間",
    Vipdg:{
        "是否开通会员":"是否開通會員？",
        "非会员附件不能超过150M开通课堂派VIP可上传2G附件另外尊享更多VIP会员功能":"非會員附件不能超過150M，開通課堂派VIP可上傳2G附件，另外尊享更多VIP會員功能",
        "开通VIP":"開通VIP",
        "非VIP最多可创建50个课程包含删除和归档的课程您的课程已达到上限开通VIP可继续创建课程并且无上线另外VIP可尊享更多权益":'非VIP最多可創建50個課程（包含刪除和歸檔的課程），您的課程已達到上限，開通VIP可繼續創建課程並且無上線，另外VIP可尊享更多權益',
        "您当时是学生VIP无法转换成老师身份如有特殊需要请联系客服进行修改":"您當時是學生VIP，無法轉換成老師身份，如有特殊需要，請聯系客服進行修",
        "vip限时特惠":"vip限時特惠",
        "当前弹幕特效体验次数已用完开通vip畅享超酷弹幕特效和更多权益":"當前彈幕特效體驗次數已用完，開通vip，暢享超酷彈幕特效和更多權益！",
        "开通vip可继续使用弹幕效果是否开通vip":"開通vip可繼續使用彈幕效果，是否開通vip？",
    },
    "读取中":"讀取中...",
    "上传中":"上傳中...",
    "上传完成":"上傳完成",
    "此视频暂无法播放请稍后再试":"此視頻暫無法播放，請稍後再試",
    "该资源无法提供下载":"該資源無法提供下載！",
    "已经是第一页":"已經是第壹頁",
    "已经是最后一页":"已經是最後壹頁",
    "确定要删除吗":"確定要刪除嗎",
    "提醒":"提醒",
    "标题":"標題",
    "从备课区导入":"從備課區導入",
    "从课程导入":"從課程導入",
    "从慕课资源导入":"從慕課資源導入",
    "请输入内容":"請輸入內容",
    "人次学习":"人次學習",
    "全部学校":"全部學校",
    "全部专业":"全部專業",
    "正在导入":"正在導入...",
    "数字评价题":"數字評價題",
    "颜色选择":"顏色選擇",
    "默认":"默認",
    "动画选择":"動畫選擇",
    "弹幕动画预览":"彈幕動畫預覽",
    "无":"無",
    "立即参与":"立即參與",
    "人发表意见":"人發表意見",
    "查看":"查看",
    "个名额共":"個名額，（共",
    "个）":"個）",
    "暂无记录":"暫無記錄",
    "暂无内容发表第一条弹幕吧":"暫無內容，發表第壹條彈幕吧",
    "加入互动":"加入互動",
    "暂无互动试题":"暫無互動試題",
    "老师已关闭弹幕":"老師已關閉彈幕",
    "发言历史":"發言歷史",
    "老师暂未开启直播课件同屏":"老師暫未開啟直播",
    "如未自动播放请点击播放":"如未自動播放，請點擊播放",
    "同屏中":"同屏中",
    "连接失败":"連接失敗",
    "刷新一下":"刷新壹下",
    "发言":"發言",
    "弹幕记录":"彈幕記錄",
    "课堂记录":"課堂記錄",
    "展开画面":"展開畫面",
    "请答题":"請答題",
    "历史发言":"歷史發言",
    "老师已开启抢答":"老師已開啟搶答",
    "是否抢答":"是否搶答",
    "正在直播上课":"正在直播/上課",
    "课堂已结束正在检查是否有互动和抢答":"課堂已結束！正在檢查，是否有互動和搶答",
    "抢答已结束":"搶答已結束",
    "老师已禁止弹幕":"老師已禁止彈幕",
    "发送成功":"發送成功",
    "本次课堂已结束":"本次課堂已結束",
    "老师已开启弹幕":"老師已開啟彈幕",
    "老师已关闭同屏":"老師已關閉同屏",
    "老师已开启同屏":"老師已開啟同屏",
    "老师已关闭直播":"老師已關閉直播",
    "老师发起了互动答题":"老師發起了互動答題",
    "是否参与答题":"是否參與答題",
    "加入":"加入",
    "已将疑问标记给老师":"已將疑問標記給老師",
    "已取消疑问":"已取消疑問",
    "活动类型名称10字以内":"活動類型名稱（10字以內）",
    "新建活动内容":"新建活動內容",
    "请输入活动名称":"請輸入活動名稱",
    "课程达成度指标":"課程達成度指標",
}